export default {
  data() {
    return {
      salaryOptions: {
        hourly: {
          '4.00-4.49': '4.00 - 4.49',
          '4.50-4.99': '4.50 - 4.99',
          '5.00-5.49': '5.00 - 5.49',
          '5.50-5.99': '5.50 - 5.99',
          '6.00-6.49': '6.00 - 6.49',
          '6.50-6.99': '6.50 - 6.99',
          '7.00-7.49': '7.00 - 7.49',
          '7.50-7.99': '7.50 - 7.99',
          '8.00-8.49': '8.00 - 8.49',
          '8.50-8.99': '8.50 - 8.99',
          '9.00-9.49': '9.00 - 9.49',
          '9.50-9.99': '9.50 - 9.99',
          '10.00-10.99': '10.00 - 10.99',
          '11.00-11.99': '11.00 - 11.99',
          '12.00-12.99': '12.00 - 12.99',
          '13.00-13.99': '13.00 - 13.99',
          '14.00-14.99': '14.00 - 14.99',
          '15.00-15.99': '15.00 - 15.99',
          '16.00-16.99': '16.00 - 16.99',
          '17.00-17.99': '17.00 - 17.99',
          '18.00-18.99': '18.00 - 18.99',
          '19.00-19.99': '19.00 - 19.99',
          '20.00-22.49': '20.00 - 22.49',
          '22.50-24.99': '22.50 - 24.99',
          '25.00-27.49': '25.00 - 27.49',
          '27.50-29.99': '27.50 - 29.99',
          '30.00-32.49': '30.00 - 32.49',
          '32.50-34.99': '32.50 - 34.99',
          '35.00-37.49': '35.00 - 37.49',
          '37.50-39.99': '37.50 - 39.99',
          '40.00-44.99': '40.00 - 44.99',
          '45.00-49.99': '45.00 - 49.99',
          '50.00-54.99': '50.00 - 54.99',
          '55.00-59.99': '55.00 - 59.99',
          '60.00-69.99': '60.00 - 69.99',
          '70.00-79.99': '70.00 - 79.99',
          '80.00-89.99': '80.00 - 89.99',
          '90.00-99.99': '90.00 - 99.99',
          '100.00-124.99': '100.00 - 124.99',
          '125.00-149.99': '125.00 - 149.99',
          '150.00': '150.00+',
        },
        annual: {
          '5000-6000': '5,000 - 6,000',
          '6000-7000': '6,000 - 7,000',
          '7000-8000': '7,000 - 8,000',
          '8000-9000': '8,000 - 9,000',
          '9000-10000': '9,000 - 10,000',
          '10000-12000': '10,000 - 12,000',
          '12000-14000': '12,000 - 14,000',
          '14000-16000': '14,000 - 16,000',
          '16000-18000': '16,000 - 18,000',
          '18000-20000': '18,000 - 20,000',
          '20000-22000': '20,000 - 22,000',
          '22000-24000': '22,000 - 24,000',
          '24000-26000': '24,000 - 26,000',
          '26000-28000': '26,000 - 28,000',
          '28000-30000': '28,000 - 30,000',
          '30000-35000': '30,000 - 35,000',
          '35000-40000': '35,000 - 40,000',
          '40000-45000': '40,000 - 45,000',
          '45000-50000': '45,000 - 50,000',
          '50000-60000': '50,000 - 60,000',
          '60000-70000': '60,000 - 70,000',
          '70000-80000': '70,000 - 80,000',
          '80000-90000': '80,000 - 90,000',
          '90000-100000': '90,000 - 100,000',
          '100000-125000': '100,000 - 125,000',
          '125000-150000': '125,000 - 150,000',
          '150000-175000': '150,000 - 175,000',
          '175000-200000': '175,000 - 200,000',
          '200000+': '200,000+',
        },
      },
    };
  },
  props: {
    salaryExpectation: {
      type: String,
    },
    salaryExpectationUnit: {
      type: String,
    },
  },
  methods: {
    onSalaryExpectationUnitSelect(salaryExpectationUnit) {
      this.$emit('changeParameter', {
        key: 'salaryExpectationValue',
        value: null,
      });
      this.$emit('changeParameter', {
        key: 'salaryExpectationUnit',
        value: salaryExpectationUnit,
      });
    },
  },
};
